import { Input } from '@/components/ui/input'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import type { Control } from 'react-hook-form'
import type { FormValues } from './agent-detail.schema'

type EmailCardContentProps = {
  control: Control<FormValues>
}

export function EmailCardContent({ control }: EmailCardContentProps) {
  return (
    <FormField
      control={control}
      name="emailSubject"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Email subject</FormLabel>
          <FormControl>
            <Input
              placeholder="e.g. Thanks {{firstName}} for your interest in {{property}}"
              maxLength={100}
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

/** Placeholder kept for barrel export compatibility */
export function EmailCard() {
  return null
}
